import React, { Suspense, lazy } from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { ClipLoader } from "react-spinners";
import { retry } from '../../utils/PromiseRetry';
import { PrivateRoute, PublicRoute } from './routesConfig';


//const ComingSoon = lazy(() => retry(() => import('../components/ComingSoon')));
const Home = lazy(() => retry(() => import('../components/Home')));
const LoginForm = lazy(() => retry(() => import('../components/LoginForm')));
const BecomeMember = lazy(() => retry(() => import('../components/BecomeMember')));
const ThankYouPage = lazy(() => retry(() => import('../components/ThankYouPage')));
const Signout = lazy(() => retry(() => import('../components/Signout')));
const KittyClubhouse = lazy(() => retry(() => import('../components/KittyClubhouse')));
const LevelUpCelebration = lazy(() => retry(() => import('../components/LevelUpCelebration')));
const SocialClub = lazy(() => retry(() => import('../components/SocialClub')));
const MeetingSpace = lazy(() => retry(() => import('../components/MeetingSpace')));
const ContactUs = lazy(() => retry(() => import('../components/ContactUs')));
// const MembershipPage = lazy(() => retry(() => import('../components/MembershipPage')));
const UserProfile = lazy(() => retry(() => import('../components/UserProfile')));
const YourBooking = lazy(() => retry(() => import('../components/UserProfile/YourBooking')));
const Transacrions = lazy(() => retry(() => import('../components/UserProfile/Transaction')));
// const CouponList = lazy(() => retry(() => import('../components/UserProfile/Coupons')));
const CodeOfConduct = lazy(() => retry(() => import('../components/CodeOfConduct')));
const PrivacyPolicy = lazy(() => retry(() => import('../components/Privacy')));
const Terms = lazy(() => retry(() => import('../components/Terms')));

const router = createBrowserRouter([
    {
        path: '/',
        errorElement: <Navigate to={"/"} />,
        children: [
            //{ path: "/", element: <PublicRoute element={<ComingSoon />} /> },
            { path: "/", element: <PublicRoute element={<Home />} /> },
            { path: "login", element: <PublicRoute element={<LoginForm />} /> },
            { path: "unlock-benefits", element: <PrivateRoute element={<BecomeMember pageType={"UNLOCK_BENEFITS"}/>} /> },
            { path: "thank-you", element: <PublicRoute element={<ThankYouPage />} /> },
            { path: "signout", element: <Signout /> },
            { path: "kitty-clubhouse", element: <PublicRoute element={<KittyClubhouse />} /> },
            { path: "level-up-celebration", element: <PublicRoute element={<LevelUpCelebration />} /> },
            { path: "social-club", element: <PublicRoute element={<SocialClub />} /> },
            { path: "meeting-space", element: <PublicRoute element={<MeetingSpace />} /> },
            { path: "contact-us", element: <PublicRoute element={<ContactUs />} /> },
            // { path: "membership", element: <PublicRoute element={<MembershipPage />} /> },
            { path: "profile", element: <PrivateRoute element={<UserProfile />} /> },
            { path: "your-booking", element: <PrivateRoute element={<YourBooking />} /> },
            { path: "transactions", element: <PrivateRoute element={<Transacrions />} /> },
            // { path: "coupons", element: <PrivateRoute element={<CouponList />} /> },
            { path: "clubs-rules", element: <PublicRoute element={<CodeOfConduct />} /> }, 
            { path: "profile/edit", element: <PrivateRoute element={<BecomeMember pageType={"EDIT_PROFILE"} />} /> },   
            { path: "privacy-policy", element: <PrivacyPolicy /> },
            { path: "terms-condition", element: <Terms /> },
        ],
    },
]);


const AppRouter = () => {
    return (
        <Suspense fallback={
            <span style={{ textAlign: "center", display: "block" }}>
                <div style={{ display: "inline-block", marginTop: "300px" }}>
                    <ClipLoader
                        color={"#D35927"}
                        loading={true}
                        size={150}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            </span>}>
            <RouterProvider router={router} />
        </Suspense>
    );
}

export default AppRouter;
